import { useEffect, useState } from 'react'
import { fbt } from 'fbtee'
import { useAuth } from '@/hooks/useAuth'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { BeaconLogo } from '@/components/BeaconLogo'
import { markRenameNoticeSeen, recordRenameNoticeShown, shouldShowRenameNotice } from '@/lib/rename'

// "Beacon is now Faro" card for people who used the app before the rename (#585).
// Gated per device/account in lib/rename.ts; retires on "Got it", after three
// launches it was seen in, or a year after the rename.
export function RenameNotice() {
  const { user } = useAuth()
  // Re-evaluated as auth resolves: an older account on a fresh device qualifies only once `user` loads.
  const [dismissed, setDismissed] = useState(false)
  const visible = !dismissed && shouldShowRenameNotice(user)
  useEffect(() => {
    if (visible) recordRenameNoticeShown()
  }, [visible])
  if (!visible) return null

  return (
    <Card className="flex flex-col gap-3 border-primary/30 bg-primary/10 p-4" data-testid="rename-notice">
      <div className="flex items-center gap-3">
        <BeaconLogo className="size-10 flex-none" />
        <h2 className="text-lg font-bold leading-tight">
          {fbt('Beacon is now Faro', 'Title of the one-time card announcing the app was renamed from Beacon to Faro')}
        </h2>
      </div>
      <p className="text-sm text-muted-foreground">
        <fbt desc="Body of the one-time card announcing the app was renamed from Beacon to Faro">
          Same app, new name. Your crew and your plans are still here.
        </fbt>
      </p>
      <Button
        className="w-fit"
        onClick={() => {
          markRenameNoticeSeen()
          setDismissed(true)
        }}
      >
        <fbt desc="Button that dismisses the card announcing the rename from Beacon to Faro">Got it</fbt>
      </Button>
    </Card>
  )
}
